"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/BlockListTab/BlockedMessagesModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);








var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _phone = require('shared/services/phone');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);









const formatReceivedAt = (receivedAt) => {
  const received = _moment2.default.call(void 0, receivedAt)
  return received.isValid() ? received.format('MM/DD/YYYY h:mm A') : ''
}

const BlockedMessagesModal = ({
  block,
  isOpen,
  onClose,
  orgKey,
  teamKey,
}) => {
  const [messages, setMessages] = _react.useState([])
  const [isLoading, setIsLoading] = _react.useState.call(void 0, false)
  const [hasError, setHasError] = _react.useState.call(void 0, false)

  _react.useEffect.call(void 0, () => {
    if (!isOpen || !block) {
      setMessages([])
      setHasError(false)
      return
    }

    setIsLoading(true)
    setHasError(false)
    _actions2.default.getPhoneNumberBlockedMessages({
      OrgKey: orgKey,
      TeamKey: teamKey,
      PhoneNumber: block.BlockedPhoneNumber,
      Limit: 30,
      Offset: 0,
    })
      .then(({ Messages }) => setMessages(Messages))
      .catch(() => setHasError(true))
      .finally(() => setIsLoading(false))
  }, [block, isOpen, orgKey, teamKey])

  const blockedPhoneNumber = _optionalChain([block, 'optionalAccess', _ => _.BlockedPhoneNumber]) || ''

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      onClose: onClose,
      title: "Blocked messages" ,
      className: "team-page--block-list--messages-modal",
      bodyClassName: "team-page--block-list--messages-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 63}}

      , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 70}}
        ,  _phone.formatPhoneNumber.call(void 0, blockedPhoneNumber) || blockedPhoneNumber 
      )
      ,  isLoading && (
        _react2.default.createElement('div', { className: "team-page--block-list--messages-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 74}}, "Loading blocked messages..."

        )
      )
      ,  hasError && !isLoading && (
        _react2.default.createElement('div', { className: "team-page--block-list--messages-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}, "Failed to load blocked messages"

        )
      )
      ,  !hasError && !isLoading && !messages.length && (
        _react2.default.createElement('div', { className: "team-page--block-list--messages-empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}, "No blocked messages"

        )
      )
      ,  !hasError && !isLoading && !!messages.length && (
        _react2.default.createElement('div', { className: "team-page--block-list--messages-list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}}
          ,  messages.map(message => (
            _react2.default.createElement('div', {
              key: message.MessageKey,
              className: "team-page--block-list--message", __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}

              , _react2.default.createElement('div', { className: "team-page--block-list--message-time", __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
                ,  formatReceivedAt(message.ReceivedAt) 
              )
              , _react2.default.createElement('div', { className: "team-page--block-list--message-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}}
                ,  message.MessageBody || '[No text]' 
              )
              ,  message.NumMedia > 0 && (
                _react2.default.createElement('div', { className: "team-page--block-list--message-media", __self: this, __source: {fileName: _jsxFileName, lineNumber: 102}}
                  ,  message.NumMedia , " attachment" ,  message.NumMedia === 1 ? '' : 's' 
                )
              )
            )
          ))
        )
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Close",
        onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
      )
    )
  )
}

exports. default = BlockedMessagesModal
